import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

//*MUI
import { Box, Modal, Divider, TextField } from '@mui/material';
import EditIcon from '../../Components/Icons/EditIcon';


//*Redux
import { useDispatch } from 'react-redux';
import action from '../../Redux Store/actions';

//*files
import cssClasses from "./ChangeBulkUnitStatus.module.css"
import Button from '../../Subcomponents/Button';
import Close from '../../Components/Icons/Close';
import { getAllInventoryStatusFromTable, getUnitByUnitNo, UpdateLeadIdToInventory } from '../../Services/SustenanceService';
import DropDown from '../../Subcomponents/DropDown';
import { getUnitStatus, UpdateUnitStatus } from '../../Services/Event';
import { errorTost, infoTost, successTost } from '../../Services/Toast';
import { insertInventoryLogs } from '../../Services/AllAllotments';
import { useSelector } from 'react-redux';
import { supabase } from '../../supabaseClient';
import { getHoldTypes } from '../../Services/Bank';

const style = {
  position: 'absolute',
  top: '55%',
  left: '47%',
  transform: 'translate(-50%, -50%)',
  // width: 'Fit-Content',
  // height: 'Fit-Content',
  bgcolor: 'background.paper',
  borderRadius: '8px',
  boxShadow: 24,
};

function ChangeBulkUnitStatus({ open, handleClose, RespValue, units }) {
  let { unitNo } = useParams();
  const dispatch = useDispatch();
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  const [Units, setUnits] = useState([]);
  const [StatusList, setStatusList] = useState([]);
  const [holdTypes, setHoldTypes] = useState([]); 
  const [ChangeUnitStatusDetails, setChangeUnitStatusDetails] = useState({
    UnitStatus: '',
    unitStatusString: '',
    Reason: '',
    holdReason: '',
    customReason: '',
  });
  const [HelperText, setHelperText] = useState({
    UnitStatus: '',
    Reason: '',
    holdReason: ''
  })



  useEffect(() => {
    dispatch(action.activeMenu('project'));
    setUnits(units);
    getProject();
  }, []);


 
  function getProject() {
    getAllInventoryStatusFromTable().then((resp) => {
      const filteredStatusList = resp.data;
      setStatusList(filteredStatusList);

      // Check if unit status is "Available" and the user has "Hold/Release" access
      // if (units.length > 0 && units[0]?.inventoryStatusId?.status === 'Available' && isHoldReleaseAccessible) {
        // Only show "Locked" status if the unit is "Available" and the user has access
        // setStatusList([filteredStatusList.find(status => status.status === 'Locked')]);
      // } else {
        // Otherwise show all statuses, except "Available"
        // const filteredStatuses = filteredStatusList.filter(status => status.status !== "Available" || isHoldReleaseAccessible);
      // }
    })
  }
const isLocked = ChangeUnitStatusDetails?.unitStatusString === "Reserved";
const isOnHold = ChangeUnitStatusDetails?.unitStatusString === "On Hold";


  

async function UpdateStatus() {

  // ✅ Reason validation for Locked & On Hold
  if (isLocked || isOnHold) {
    if (!ChangeUnitStatusDetails.Reason?.trim()) {
      setHelperText((prev) => ({
        ...prev,
        Reason: "Reason is required",
      }));
      return;
    }

    if (ChangeUnitStatusDetails.Reason.trim().length < 5) {
      setHelperText((prev) => ({
        ...prev,
        Reason: "Reason must be at least 5 characters long",
      }));
      return;
    }
  }

  let updateCount = 0;
  console.log("Units", Units)

  if (Units.length > 0) {
    Units.forEach((unit) => {
      console.log("unit:", unit);
      const unitNo = unit.unitId;

      getUnitStatus(unitNo).then((response) => {
        console.info("Unit-Status", response);

        const currentStatusId =
          response[0]?.InventoryStatus?.inventoryStatusId;

        const selectedStatusId = ChangeUnitStatusDetails.UnitStatus;

        // ✅ CASE 1: STATUS ACTUALLY CHANGED
        if (currentStatusId !== selectedStatusId) {

          UpdateUnitStatus(selectedStatusId, unitNo)
            .then(async (rep) => {
              console.info("Status-Updated", rep);

              const InventoryLogObj = {
                userId: loggedInUser?.userId,
                status: ChangeUnitStatusDetails.unitStatusString,
                unitId: unitNo,
                unitStatusChangeReason: ChangeUnitStatusDetails.Reason,
                holdReason: ChangeUnitStatusDetails.holdReason,
              };


              insertInventoryLogs(InventoryLogObj)
                .then((res) => {
                  console.log("LOG INSERT SUCCESS:", res);
                })
                .catch((err) => {
                  console.error("LOG INSERT FAILED:", err);
                });

              updateCount++;

              // Existing flow untouched
              if (unit.leadId) {
                let allotmentRes = await supabase
                  .from("AllotmentPayment")
                  .update({ status: "Released" })
                  .eq("unitId", unit.unitId)
                  .eq("leadId", unit.leadId.leadId)
                  .select();

                if (allotmentRes?.data?.[0]?.paymentId) {
                  await supabase
                    .from("EventTokenLeadRelations")
                    .update({ status: "active" })
                    .eq("paymentId", allotmentRes.data[0].paymentId);
                }

                await supabase
                  .from("LeadStatus")
                  .update({
                    status: allotmentRes?.data?.[0]?.paymentId
                      ? "Checkpoint Two Cleared"
                      : "Site Visit Done",
                  })
                  .eq("leadId", unit.leadId.leadId);

                UpdateLeadIdToInventory({ leadId: null }, unitNo).catch((err) =>
                  console.error("UpdateLeadIdToInventory", err)
                );
              }

              if (updateCount === Units.length) {
                handleClose();
                successTost("Unit status updated successfully!");
                RespValue(true);
              }
            })
            .catch((err) => {
              console.error("UpdateUnitStatus", err);
            });
        }

        // ✅ CASE 2: STATUS SAME BUT ON HOLD → SAVE REASON ONLY
        else if (isOnHold) {

          const InventoryLogObj = {
            userId: loggedInUser?.userId,
            status: ChangeUnitStatusDetails.unitStatusString, // On Hold
            unitId: unitNo,
            unitStatusChangeReason: ChangeUnitStatusDetails.Reason,
            holdReason: null,
          };

          console.log("ON HOLD REASON ONLY LOG:", InventoryLogObj);

          insertInventoryLogs(InventoryLogObj)
            .then((res) => {
              console.log("ON HOLD LOG SAVED:", res);
            })
            .catch((err) => {
              console.error("ON HOLD LOG FAILED:", err);
            });

          updateCount++;

          if (updateCount === Units.length) {
            handleClose();
            successTost("Unit status updated successfully!");
            RespValue(true);
          }
        }

        // ✅ CASE 3: SAME STATUS & NOT ON HOLD → DO NOTHING
        else {
          updateCount++;
          if (updateCount === Units.length) {
            handleClose();
            successTost("Unit status updated successfully!");
            RespValue(true);
          }
        }
      });
    });
  } else {
    infoTost("Please select unit to proceed");
  }
}

   useEffect(() => {
      const fetchHoldTypes = async () => {
        try {
          const response = await getHoldTypes();
          console.log("API response:", response);  

          if (response && Array.isArray(response.data)) {
            setHoldTypes(response.data); 
          } else {
            console.error("Expected an array in 'data' key, but received:", response);
          }
        } catch (error) {
          console.error("Error fetching hold types:", error);
        }
      };
   fetchHoldTypes();
  }, []);

  return (
    <>
      <Modal
        open={open}
        onClose={(_, reason) => {
          if (reason !== "backdropClick") {
            handleClose();
          }
        }}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={style}>
          <Box className={cssClasses.headerDiv}>
            <Box className={cssClasses.flexRow}>
              <Box className={cssClasses.flexCol}>
                <Box className={cssClasses.flexRow}>
                  <Box className={cssClasses.HeaderTitle}>Change Unit Status</Box>
                  {/* <Box mt={0.4}>
                    <EditIcon color={'#000000'} fill={'none'} />
                  </Box> */}
                </Box>
                <Box className={cssClasses.bhkTitle}>{Units?.inventoryTypeId?.type}</Box>
              </Box>
              <Box ml={'auto'} mt={1} onClick={handleClose} style={{ cursor: "pointer" }}>
                <Close width={'1.2rem'} height={'1.2rem'} />
              </Box>
            </Box>
          </Box>
          <Box>

            <Box margin={"3rem"} className={cssClasses.ThirdDiv}>
              <Box className={cssClasses.InputTitle} width={"85px"} mt={1.5}>
                Unit Status :
              </Box>

              <Box className={cssClasses.widthBox}>
                <DropDown
                  placeHolder="Select"
                  list={StatusList.map((element) => ({
                    label: element.status,
                    value: element.inventoryStatusId,
                  }))}
                  selectedValue={ChangeUnitStatusDetails.UnitStatus}
                  onChangeSelect={(value) => {
                    setChangeUnitStatusDetails((prev) => ({
                      ...prev,
                      UnitStatus: value,
                      unitStatusString:
                        StatusList.find((s) => s.inventoryStatusId === value)?.status || "",
                    }));
                  }}
                  style={{
                    background: "#F2F4F7",
                    selectedColor: "#667085",
                  }}
                />
              </Box>
            </Box>

            {/* {ChangeUnitStatusDetails?.unitStatusString === "Locked" && (
              <Box margin={"3rem"} className={cssClasses.ThirdDiv}>
                <Box className={cssClasses.InputTitle} width={"85px"} mt={1.5}>
                  Locked Reason:<span style={{ color: "red" }}>*</span>
                </Box>

                <Box className={cssClasses.widthBox}>
                  <DropDown
                    placeHolder="Select"
                    list={[
                      { label: "Change of Design", value: "Change of Design" },
                      { label: "Management Hold", value: "Management Hold" },
                      { label: "Leased/Preleased", value: "Leased/Preleased" },
                      { label: "Amenities", value: "Amenities" },
                      { label: "Future Sell", value: "Future Sell" },
                      { label: "Custom Reason", value: "Custom Reason" }
                    ]}
                    selectedValue={ChangeUnitStatusDetails?.holdReason}
                    onChangeSelect={(value) => {
                      setChangeUnitStatusDetails((prev) => ({
                        ...prev,
                        holdReason: value, // Store in holdReason
                        unitStatusChangeReason: value === "Custom Reason" ? "" : "", // Clear the Reason field
                      }));

                      setHelperText((prev) => ({
                        ...prev,
                        holdReason: value ? "" : "Please select reason",
                      }));
                    }}
                    style={{
                      background: "#F2F4F7",
                      selectedColor: "#667085",
                    }}
                    helperText={HelperText?.holdReason}
                  />
                </Box>
              </Box>
            )} */}
            {isLocked && (
  <Box margin={"3rem"} className={cssClasses.ThirdDiv}>
    <Box className={cssClasses.InputTitle} width={"85px"} mt={1.5}>
      Reserved Reason:<span style={{ color: "red" }}>*</span>
    </Box>

    <Box className={cssClasses.widthBox}>
      <DropDown
        placeHolder="Select"
        // list={[
        //   { label: "Change of Design", value: "Change of Design" },
        //   { label: "Management Hold", value: "Management Hold" },
        //   { label: "Leased/Preleased", value: "Leased/Preleased" },
        //   { label: "Amenities", value: "Amenities" },
        //   { label: "Future Sell", value: "Future Sell" },
        //   { label:  "Landowner", value:"Landowner"},
        //   { label: "Custom Reason", value: "Custom Reason" },
        // ]}
        list={holdTypes.map((holdType) => ({
                label: holdType.HoldType,
                value: holdType.HoldType  
              }))}
        selectedValue={ChangeUnitStatusDetails?.holdReason}
        onChangeSelect={(value) => {
          setChangeUnitStatusDetails((prev) => ({
            ...prev,
            holdReason: value,
          }));
        }}
      />
    </Box>
  </Box>
)}


            {/* {ChangeUnitStatusDetails?.unitStatusString === "Locked" && (
              <Box margin={"3rem"} className={cssClasses.ThirdDiv}>
                <Box className={cssClasses.InputTitle} width={"85px"} mt={1.5}>
                  Reason:<span style={{ color: "red" }}>*</span>
                </Box>

                <Box className={cssClasses.widthBox}>
                  <TextField
                    placeholder="Enter reason"
                    fullWidth
                    size="small"
                    value={ChangeUnitStatusDetails?.unitStatusChangeReason || ""}
                    onChange={(e) => {
                      const value = e.target.value;

                      setChangeUnitStatusDetails((prev) => ({
                        ...prev,
                        unitStatusChangeReason: value,
                        Reason: value || '',
                      }));

                      setHelperText((prev) => ({
                        ...prev,
                        unitStatusChangeReason: !value.trim()
                          ? "Reason is required"
                          : value.trim().length < 5
                            ? "Reason must be at least 5 characters long"
                            : "",
                      }));
                    }}
                    error={HelperText?.unitStatusChangeReason !== ""}
                    helperText={HelperText?.unitStatusChangeReason}
                    sx={{
                      '& .MuiFormHelperText-root': {
                        fontSize: '1.2rem', // Increase font size here
                      },
                    }}
                  />
                </Box>
              </Box>
            )} */}

{(isLocked || isOnHold) && (
  <Box margin={"3rem"} className={cssClasses.ThirdDiv}>
    <Box className={cssClasses.InputTitle} width={"85px"} mt={1.5}>
      Reason:<span style={{ color: "red" }}>*</span>
    </Box>

    <Box className={cssClasses.widthBox}>
      <TextField
        sx={{
              "& .MuiInputBase-input": {
                fontSize: "16px",   // increase input text size
              },
              "& .MuiFormHelperText-root": {
                fontSize: "13px"    // optional: helper text size
              }
        }}
        placeholder="Enter reason"
        fullWidth
        size="small"
        value={ChangeUnitStatusDetails?.Reason || ""}
        onChange={(e) => {
          const value = e.target.value;

          setChangeUnitStatusDetails((prev) => ({
            ...prev,
            Reason: value,
            unitStatusChangeReason: value,
          }));

          setHelperText((prev) => ({
            ...prev,
            unitStatusChangeReason: !value.trim()
              ? "Reason is required"
              : value.trim().length < 5
              ? "Reason must be at least 5 characters long"
              : "",
          }));
        }}
        error={!!HelperText?.unitStatusChangeReason}
        helperText={HelperText?.unitStatusChangeReason}
      />
    </Box>
  </Box>
)}


          </Box>

          <Box className={cssClasses.FooterDiv}>
            <Box className={cssClasses.flexRow}>
              <Box width={'fit-Content'} ml={'auto'}>
                <Button
                  style={{
                    color: "#344054",
                    backgroundColor: "#ffffff",
                    fontSize: "1.6rem",
                    lineHeight: "2.4rem",
                  }}
                  btnName={'Discard'}
                  clicked={handleClose}
                />
              </Box>

              <Box width={'fit-Content'}>
                <Button
                  style={{
                    color: "#ffffff",
                    backgroundColor: "#155EEF",
                    fontSize: "1.6rem",
                    lineHeight: "2.4rem",
                  }}
                  disable={ChangeUnitStatusDetails.UnitStatus === ''}
                  btnName={'Save'}
                  clicked={UpdateStatus}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  )
}

export default ChangeBulkUnitStatus